export class PageRecipientBasicModel {
    constructor(payload) {
        Object.assign(this, payload);
    }
    get defaultProfilePic() {
        if (this.profilePic === ' ' && this.platformOrigin === 'facebook') {
            return require('@/assets/images/messenger-logo.svg');
        }
        return this.profilePic;
    }
}
